import type { ReactElement } from 'react';

export function PromoIcon(props: React.SVGProps<SVGSVGElement>): ReactElement {
  return (
    <svg
      fill="none"
      height="40"
      viewBox="0 0 40 40"
      width="40"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#a)">
        <path
          d="m28.793 12.929-5.1-2.983-10.353 6.93-12.6 6.321 5.121 2.956s2.707-1.354 5.21.09c1.926 1.113.82 2.254.209 2.721-.166.127-.161.31.036.42l5.117 2.873 22.932-13.334-5.209-2.936s-2.548 1.47-5.207-.065c-2.66-1.535-.156-2.993-.156-2.993Z"
          fill="#050505"
          stroke="#050505"
          strokeLinejoin="round"
          strokeWidth=".75"
        />
        <path
          d="m27.823 10.75-4.956-2.9C18.317 14.5 11.167 18.588.56 20.729l4.977 2.873s3.492-.908 5.924.497c1.778 1.026.438 1.86-.412 2.235-.264.116-.316.35-.077.484l4.84 2.716c9.042-1.14 17.224-5.844 22.285-12.958l-5.062-2.854s-1.761 1.943-4.346.451-.866-3.423-.866-3.423Z"
          fill="#fff"
          stroke="#050505"
          strokeLinejoin="round"
          strokeWidth=".75"
        />
        <path
          d="M25.482 22.398c1.81-1.056 2.133-2.308 2.133-2.308l-1.814-.222s-.334.91-1.757 1.74c-1.311.765-2.832.87-4.18.594l3.231-1.885-1.151-.658-3.542 2.066a6 6 0 0 1-.47-.241 5 5 0 0 1-.41-.26l3.544-2.067-1.152-.657-3.237 1.888c-.501-.777-.337-1.659.99-2.422 1.34-.782 2.83-.92 2.83-.92l-.124-1.108s-2.085.07-4.088 1.238l.014.009c-2.215 1.292-2.466 2.91-1.384 4.231l-1.357.792 1.151.658 1.094-.638q.197.14.417.272.222.121.459.23l-1.091.637 1.151.658 1.35-.787c2.317.627 5.146.471 7.393-.84"
          fill="#050505"
        />
        <path
          d="m38.278 16.503-4.976-2.872s-1.976 2.019-4.56.527c-2.585-1.492-.633-3.524-.633-3.524l-5.081-2.935c-1.394 2.038-2.287 3.08-4.252 4.636l15.33 8.811c1.89-1.669 2.837-2.667 4.172-4.643"
          fill="#FF9E75"
        />
        <path
          d="m33.737 20.8-14.693-8.355"
          stroke="#050505"
          strokeDasharray="2 2"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth=".75"
        />
        <path
          d="m27.823 10.75-4.956-2.9C18.317 14.5 11.167 18.588.56 20.729l4.977 2.873s3.492-.908 5.924.497c1.778 1.026.438 1.86-.412 2.235-.264.116-.316.35-.077.484l4.84 2.716c9.042-1.14 17.224-5.844 22.285-12.958l-5.062-2.854s-1.761 1.943-4.346.451-.866-3.423-.866-3.423Z"
          stroke="#050505"
          strokeLinejoin="round"
          strokeWidth=".75"
        />
      </g>
      <defs>
        <clipPath id="a">
          <path d="M0 0h40v40H0z" fill="#fff" />
        </clipPath>
      </defs>
    </svg>
  );
}
